import NProgress from 'nprogress';
import logger from '@utils/logger';
class BaseStore {
  withProgress = function <T>(request: (...args) => Promise<T>): (...args) => Promise<T> {
    return (...args) => new Promise<T>((resolve, reject) => {
      NProgress.start();
      request(...args).then(data => {
        NProgress.done();
        resolve(data);
      }).catch(e => {
        logger.error(e);
        NProgress.done();
        reject();
      });
    });
  };
}
export default BaseStore;